/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Cell, FormControl, Grid, isEmpty, VFlow } from 'bold-ui'
import { ErrorField } from 'components/form'
import { CboCuidadoCompartilhadoSelectModel } from 'components/form/field/select/CboCuidadoCompartilhadoSelectField/CboCuidadoCompartilhadoSelectField'
import { CiapSelectField } from 'components/form/field/select/CiapSelectField/CiapSelectField'
import { CidSelectField } from 'components/form/field/select/CidSelectField/CidSelectField'
import { CiapCapituloEnum } from 'graphql/types.generated'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { Fragment } from 'react'
import { useField } from 'react-final-form'
import { isUndefinedOrNull } from 'util/checks'
import { MetaRoot } from 'util/metaPath'

import { CuidadoCompartilhadoPlanoModel } from '../model-cuidadocompartilhado'

interface CuidadoCompartilhadoProblemasCondicoesFieldsProps {
  path: MetaRoot<CuidadoCompartilhadoPlanoModel>
  isGuiaEncaminhamento: boolean
  isEdit: boolean
  disabled: boolean
}

export default function CuidadoCompartilhadoProblemasCondicoesFields(
  props: Readonly<CuidadoCompartilhadoProblemasCondicoesFieldsProps>
) {
  const { path, isGuiaEncaminhamento, isEdit, disabled } = props

  const {
    cidadao,
    permissoes: { somenteCiap },
  } = useAtendimentoContext()

  const {
    input: { value: ciapValue },
  } = useField<CboCuidadoCompartilhadoSelectModel>(path.problemasECondicoes.ciap.absolutePath(), {
    subscription: { value: true },
  })

  const identidadeGeneroEmpty = isEmpty(cidadao?.identidadeGeneroDbEnum)
  const sexoCidadao = identidadeGeneroEmpty ? cidadao?.sexo : null
  const idadeEmAnos = cidadao.idadeEmAnos
  const ciapId = ciapValue?.id

  const cid10DisabledGuia = disabled || (somenteCiap && isUndefinedOrNull(ciapId))
  const ciapRelacionadaGuia = somenteCiap ? ciapId : null

  const cid10DisabledNotGuia = disabled || somenteCiap

  return (
    <Cell size={12}>
      <VFlow vSpacing={0.5}>
        <FormControl label='Problemas/condições' required>
          <Grid>
            {isGuiaEncaminhamento ? (
              <Fragment>
                {(somenteCiap || isEdit) && (
                  <Cell size={6}>
                    <CiapSelectField
                      name={path.problemasECondicoes.ciap}
                      label='CIAP 2'
                      idadeCidadaoEmAnos={idadeEmAnos}
                      sexo={sexoCidadao}
                      capitulosExcluidos={[CiapCapituloEnum.PROCEDIMENTOS]}
                      excluirCIAPsDAB
                      menuMinWidth={620}
                      disabled={disabled || !somenteCiap}
                    />
                  </Cell>
                )}
                <Cell size={6}>
                  <CidSelectField
                    name={path.problemasECondicoes.cid10}
                    label='CID 10'
                    renderGrupoCiapRelacionada={somenteCiap}
                    idadeCidadaoEmAnos={idadeEmAnos}
                    sexo={sexoCidadao}
                    ciapRelacionada={ciapRelacionadaGuia}
                    somenteRelacionados={somenteCiap}
                    disabled={cid10DisabledGuia}
                  />
                </Cell>
              </Fragment>
            ) : (
              <Fragment>
                <Cell size={6}>
                  <CiapSelectField
                    name={path.problemasECondicoes.ciap}
                    label='CIAP 2'
                    idadeCidadaoEmAnos={idadeEmAnos}
                    sexo={sexoCidadao}
                    capitulosExcluidos={[CiapCapituloEnum.PROCEDIMENTOS]}
                    excluirCIAPsDAB
                    menuMinWidth={620}
                    disabled={disabled}
                  />
                </Cell>
                {(!somenteCiap || isEdit) && (
                  <Cell size={6}>
                    <CidSelectField
                      name={path.problemasECondicoes.cid10}
                      label='CID 10'
                      renderGrupoCiapRelacionada
                      idadeCidadaoEmAnos={idadeEmAnos}
                      ciapRelacionada={ciapId}
                      sexo={sexoCidadao}
                      disabled={cid10DisabledNotGuia}
                    />
                  </Cell>
                )}
              </Fragment>
            )}
          </Grid>
        </FormControl>
        <ErrorField name={path.problemasECondicoes} ignoreObjectError />
      </VFlow>
    </Cell>
  )
}
